//import { RouteGroup } from "../core";
//import RichiestaMateriale from './components/RichiestaMateriale';
//import ElencoOrdini from './components/ElencoOrdini';

export const NAME = "ordini";

export const routes = {
    main: '/ordini',
    materiale: '/ordini/materiale',
    elenco: '/ordini/elenco',
}

/*
export const routes: RouteGroup = [
    {
        kind: "anagrafica",
        path: '/ordini/materiale',
        icon: 'zip',
        component: RichiestaMateriale,
        enabled: moduli => moduli.ordini
    },
    {
        kind: "separator"
    },
    {
        kind: "anagrafica",
        path: '/ordini/elenco',
        icon: 'list',
        component: ElencoOrdini,
        enabled: moduli => moduli.ordini
    }
]
*/